module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJtJREFUeNpi9PDw+M8AA8gcJmQBgABiRFGGIgIQQAwYUljVAwFAAGEVJB5g1c6ERWEgQAAxEGsRE7F2M1HkSHJNDATiCwABRGGooQGQYdT3NfUVstA9CgN37NjBCLaagMJ6oNPADIAAY6BmzJAUMVQP7lEDcadEcmOTIgPxGHABiBthaRGIDVhIdQEaaASm/A1QPSBqPXWLHCAAAN9iMS27s6BPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon/zhaohu.png
// module id = 4Ps0
// module chunks = 1